import { render, staticRenderFns } from "./Register01.vue?vue&type=template&id=57913e36&scoped=true&"
import script from "./Register01.vue?vue&type=script&lang=js&"
export * from "./Register01.vue?vue&type=script&lang=js&"
import style0 from "./Register01.vue?vue&type=style&index=0&id=57913e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57913e36",
  null
  
)

export default component.exports